import { render, staticRenderFns } from "./edit-declaration-modal.vue?vue&type=template&id=3b2621e0&scoped=true"
import script from "./edit-declaration-modal.vue?vue&type=script&lang=js"
export * from "./edit-declaration-modal.vue?vue&type=script&lang=js"
import style0 from "./edit-declaration-modal.vue?vue&type=style&index=0&id=3b2621e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2621e0",
  null
  
)

export default component.exports